class Banderole {
    constructor() {
        const initCountdown = this.initCountdown.bind(this);
        this.initCountdown();
        const initCLose = this.initClose.bind(this);
        this.initClose();
    }

    initClose() {
        const baseSelector = ".banderole";
        const containers = document.querySelectorAll(baseSelector);
        containers.forEach((container) => {
            const buttons = container.querySelectorAll(
                `${baseSelector}__close`
            );
            buttons.forEach((button) => {
                button.addEventListener(
                    "click",
                    () => {
                        container.remove();
                    },
                    false
                );
            });
        });
    }

    initCountdown() {
        const baseSelector = ".banderole__countdown";
        const baseSelectorDigit = `${baseSelector}__digit`;
        const containers = document.querySelectorAll(baseSelector);
        containers.forEach((container) => {
            const endStr = container.dataset.countdown;
            if (endStr) {
                const end = new Date(endStr * 1000);
                const now = new Date();
                var diff = Math.floor((end.getTime() - now.getTime()) / 1000);
                var hours = 0;
                var minutes = 0;
                var seconds = 0;
                var days = 0;
                if (diff > 0) {
                    days = Math.floor(diff / 60 / 60 / 24);
                    hours = Math.floor((diff - days * 24 * 60 * 60) / 60 / 60);
                    minutes = Math.floor(
                        (diff - days * 24 * 60 * 60 - hours * 60 * 60) / 60
                    );
                    seconds =
                        diff -
                        days * 24 * 60 * 60 -
                        hours * 60 * 60 -
                        minutes * 60;
                    if (days < 10) days = "0" + days;
                    if (hours < 10) hours = "0" + hours;
                    if (minutes < 10) minutes = "0" + minutes;
                    if (seconds < 10) seconds = "0" + seconds;
                    days = String(days);
                    hours = String(hours);
                    minutes = String(minutes);
                    seconds = String(seconds);

                    const daySpans = container.querySelectorAll(
                        `${baseSelectorDigit}--days ${baseSelectorDigit}s`
                    );
                    daySpans.forEach((daySpan) => {
                        daySpan.innerText = days;
                    });

                    const hourSpans = container.querySelectorAll(
                        `${baseSelectorDigit}--hours ${baseSelectorDigit}s`
                    );
                    hourSpans.forEach((hourSpan) => {
                        hourSpan.innerText = hours;
                    });

                    const minuteSpans = container.querySelectorAll(
                        `${baseSelectorDigit}--minutes ${baseSelectorDigit}s`
                    );
                    minuteSpans.forEach((minuteSpan) => {
                        minuteSpan.innerText = minutes;
                    });

                    const secondSpans = container.querySelectorAll(
                        `${baseSelectorDigit}--seconds ${baseSelectorDigit}s`
                    );
                    secondSpans.forEach((secondSpan) => {
                        secondSpan.innerText = seconds;
                    });

                    const instance = this;
                    setTimeout(function () {
                        instance.initCountdown();
                    }, 1000);
                }
            }
        });
    }
}

window.Banderole = new Banderole();
